import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import AppStore from '../../stores/AppStore'
import TemplateData, { localsMessages } from '../../utility/getTemplateData'
import PostTransaction from '../confirmation/postTransaction'
import * as FPT from '../../utility/fpt'
import _isFunction from 'lodash/isFunction';

const messages = localsMessages('confirmation/pending')

export default class extends React.Component {
    static propTypes = {
		label: PropTypes.string
	};

    constructor(props) {
        super(props);

        let confirmationData = AppStore.getConfirmation() || {}

        this.state = {
			amount: confirmationData.amount || '',
			postBackData: confirmationData.postBackData || {},
			syncReturnUrl: confirmationData.syncReturnUrl || '',
			displayMyAccount: confirmationData.showAccountOverview || false,
			orgName: TemplateData.donationName ? TemplateData.donationName : '',

			autoRedirect: TemplateData.returnAutoRedirect !== '',
			autoRedirectUrl: (TemplateData.charityReturnUrl) ? TemplateData.charityReturnUrl : '',
			autoRedirectMethod: (TemplateData.returnMethod) ? TemplateData.returnMethod : ''
		};
    }

    componentDidMount() {
		this.isComponentMounted = true;

		this.serverRequest = $.post('/donate/guest/postTransaction', {}).then((response) => {
			$('.spinneroverlay').hide();
			if (response.data.confirmationData) {
				if (this.isComponentMounted) {
					this.updatePendingData(response);
				}
			}
		})

		let confData = AppStore.getConfirmation() || {}
		let trid = confData.confirmationNumber || '';

		if (TemplateData.fptPageName === 'guestULSignUp') {
			FPT.trackPage('main:donate:wps:signup:pending', 'main:donate:wps:signup:pending:web::', 'trid', trid)
		} else {
			FPT.trackPage('main:donate:wps:guest:pending', 'main:donate:wps:guest:pending:web::', 'trid', trid)
		}
	}

    updatePendingData = (response) => {
		this.setState({
			amount: response.data.confirmationData.amount || AppStore.getDonationAmount(),
			guestSignUp: response.data.confirmationData.guestSignUp || false,
			displayMyAccount: response.data.confirmationData.showAccountOverview || false
		})
	};

    componentWillUnmount() {
		this.isComponentMounted = false;
		if (this.serverRequest && _isFunction(this.serverRequest.abort)) {
			this.serverRequest.abort()
		}
	}

	handleAutoRedirect = () => {
		let finalUrl = this.state.autoRedirectUrl
		if (finalUrl.indexOf('http') != 0 && finalUrl.indexOf('//') != 0) {
		    finalUrl = '//' + finalUrl;
		}

		window.location.href = finalUrl
	}

    render() {

		let returnText = messages.label && messages.label.returnTextMember || ''
		let returnto = messages.label && messages.label.returnto || ''
		let myAccount = messages.label && messages.label.myAccount || ''
		let pending = messages.label && messages.label.pending || ''
		let pending2 = messages.label && messages.label.pending2 || ''

		returnText = returnText.replace('{orgName}', this.state.orgName)

		returnto = returnto.replace('{orgName}', this.state.orgName)

		return (
			<div>
				<div className="donate_wrapper">
					<div className="row confirmation">
						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_img_holder center-block">
								<span className="icon icon-large icon-attention-large" aria-hidden="true"></span>
							</div>
						</div>

						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_header">
								<h4 className="text-center">{pending}</h4>
								<h5 style={{ marginTop: 15, lineHeight: '1.6', fontWeight: '200' }} className="text-center">{pending2}</h5>
							</div>
						</div>

						{this.state.autoRedirect ?
							<div>
								<div className="col-xs-12 col-sm-12 col-md-12">
									<div className="confirmation_reciept_wrapper">
										<h6 className="text-center">{returnText}</h6>
									</div>
									<div className="text-center">
										<a id="returnUrl" href={this.handleAutoRedirect} className="pp_guest_btn">{returnto}</a>
									</div>
								</div>
								<PostTransaction
									orgName={this.state.orgName}
									postdata={this.state.postBackData}
									syncReturnUrl={this.state.syncReturnUrl}
									method={this.state.autoRedirectMethod}
									action={this.state.autoRedirectUrl}/>
							</div> : null
						}
						{this.state.guestSignUp ? <div></div> : null}
						{(this.state.displayMyAccount && !this.state.autoRedirect) ?
							<div className="col-xs-12 col-sm-12 col-md-12 text-center">
								<div className="pp_guest_btn_wrapper">
									<a href="/myaccount" className="btn btn-primary pp_guest_btn">{myAccount}</a>
								</div>
							</div> : null}
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./pages/guest/pending.js